(function () {
	'use strict';
	angular.module('app.setup')
		.controller('projectType', projectType);

	projectType.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', 'storeService',
		'tableService', 'leanFilterService', 'projectTypeService', 'tableRenderService'];
	function projectType($scope, $rootScope, $timeout, $uibModal, storeService,
			tableService, leanFilterService, projectTypeService, tableRenderService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'LeanProjectTypes';
		var getSpecialControl;
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;

		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddProjectType = vm.isAdmin;
		vm.addProjectType = addProjectType;
		vm.deleteProjectType = deleteProjectType;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Project Types';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Name',
				'renderer': tableRenderService.projectTypeRenderer,
				'deleteFunction': 'deleteProjectType',
				'requiredPermission': 'admin',
				'width': 400
			},
			{
				'id': 'noOfActiveProjects',
				'display': '# of Active Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'width': 300
			},
			{
				'id': 'noOfArchiveProjects',
				'display': '# of Archive Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'width': 225
			},
			{
				'id': 'noOfTemplates',
				'renderer': tableRenderService.integer,
				'display': '# of Project Templates',
				'width': 100
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/ProjectTypesReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			isGlobalReportSetting:true
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function addProjectType(projectType) {
			var projectTypeFormScope = $scope.$new();
			projectTypeFormScope.projectType = jQuery.extend({}, projectType);
			projectTypeFormScope.action = (typeof projectTypeFormScope.projectType.id !== 'undefined' ? 'Edit' : 'Add');
			projectTypeFormScope.leanDirFactoryNdx = adminConfig.factory.id;
			var opts = {
				scope: projectTypeFormScope,
				templateUrl: '/application/f/setup/projects/types/project-type-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			projectTypeFormScope.closeDialog = function () {
				instance.close();
				projectTypeFormScope.$destroy();
			};

			projectTypeFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
				}
				instance.close();
				projectTypeFormScope.$destroy();
			};
		}

		function deleteProjectType(row) {
			if ((typeof row.noOfTemplates !== 'undefined' && row.noOfTemplates > 0) ||
				(typeof row.noOfActiveProjects !== 'undefined' && row.noOfActiveProjects > 0) ||
				(typeof row.noOfArchiveProjects !== 'undefined' && row.noOfArchiveProjects > 0)
			) {
				reassignProjectTypeToDeletedType(row.id);
				return;
			}

			var confirmScope = $scope.$new();
			confirmScope.projectTypeId = row.id;
			confirmScope.additionalText = 'delete this project type';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				var projectTypeId = confirmScope.projectTypeId;
				instance.close();
				confirmScope.$destroy();
				deleteFactoryProjectType(projectTypeId);
			};
		}

		function reassignProjectTypeToDeletedType(projectTypeId) {
			var deleteProjectTypeReasignScope = $scope.$new();
			deleteProjectTypeReasignScope.selected = {};
			deleteProjectTypeReasignScope.projectTypeId = projectTypeId;
			projectTypeService.getProjectTypes(adminConfig.factory.id).then(function (list) {
				deleteProjectTypeReasignScope.projectTypes = _.filter(list, function (a) { return a.id !== projectTypeId;});
			});

			deleteProjectTypeReasignScope.delete = function () {
				deleteFactoryProjectType(deleteProjectTypeReasignScope.projectTypeId, deleteProjectTypeReasignScope.selected.projectType.id);
				deleteProjectTypeReasignScope.closeDialog();
			};

			var opts = {
				scope: deleteProjectTypeReasignScope,
				templateUrl: '/application/f/setup/projects/types/delete-project-type-template.html'
			};

			var instance = $uibModal.open(opts);
			deleteProjectTypeReasignScope.closeDialog = function () {
				instance.close();
				deleteProjectTypeReasignScope.$destroy();
			};
		}

		function deleteFactoryProjectType(projectTypeIdToDelete, newProjectTypeId) {
			projectTypeService.deleteProjectType(projectTypeIdToDelete, newProjectTypeId, adminConfig.factory.id).then(function (response) {
				var success = false;
				var message = 'Failed to delete projecttype';
				if (response === 'Project Type deleted successfully') {
					success = true;
					message = response;
					$scope.$broadcast('reloadTable');
				}
				$rootScope.$emit('toast', {
					'message': message,
					'success': success
				});
			});
		}

		function urlGenerator(type, ndx, factoryNdxs, row) {
			var url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			var stageIds = type.indexOf('Active') >= 0 ? row['activeStages'] : row['archiveStages'];
			if (type.indexOf('Supplier') >= 0) {
				url = '/application/f/home.html#/supply-chain/supplier-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			}
			url += '&projectType=' + ndx;
			url += '&projectStageId=' + stageIds;

			return url;
		}

		init();
	}
})();
